/* istanbul ignore file */
/* eslint-disable */
export const environment: {
envName: string;
kushkiUrl: string;
devTools: boolean;
firebaseConfig: {
apiKey: string;
authDomain: string;
databaseURL: string;
projectId: string;
storageBucket: string;
messagingSenderId: string;
};
rollbarId: string;
gtmId: string;
} = {
envName: "uat",
kushkiUrl: "https://api-uat.kushkipagos.com",
devTools: false,
firebaseConfig: {
apiKey:'AIzaSyAYyH7IuISpUAoCN1zN9VWr7I7FjEKwY9I',
authDomain:'kushki-97eba.firebaseapp.com',
databaseURL: 'https://kushki-97eba.firebaseio.com',
projectId: 'kushki-97eba',
storageBucket: 'kushki-97eba.appspot.com',
messagingSenderId: '821114948879'
},
rollbarId: '55c90f43758841acade2da652c08f50b',
gtmId: 'GTM-NLW4QRL'
};
